































































































































































import { Component, Vue } from 'vue-property-decorator';
import { sanitize } from 'dompurify';
import { MetaInfo } from 'vue-meta';

@Component({
  metaInfo(): MetaInfo {
    return {
      title: 'ورود',
      titleTemplate: '%s | سامانه مشتریان فناوران برتر',
    };
  },
})
export default class Login extends Vue {
  private static mobileNumberPattern = /(09[0-9]{9})|۰۹[۰۱۲۳۴۵۶۷۸۹]{9}/;
  private static verificationCodePattern = /([0-9]{4})|[۰۱۲۳۴۵۶۷۸۹]{4}/;

  private mobileNumber = '';
  private verificationCode = '';

  private sendMobileNumberLoading = false;
  private sendVerificationLoading = false;

  private retryDialog = false;
  private noService = false;
  private verificationCodeDialog = false;

  private phoneNumberRules = [
    (value: string) => !!value || 'این فیلد الزامی است',
    (value: string) => (value || '').length <= 11 || 'شماره اشتباه است',
    (value: string) => Login.mobileNumberPattern.test(value) || 'شماره اشتباه است',
  ];
  private verificationCodeRules = [
    (value: string) => !!value || 'کد تایید را وارد نمایید',
    (value: string) => Login.verificationCodePattern.test(value) || 'کد تایید اشتباه است',
  ];

  get phoneNumberInvalid() {
    return this.mobileNumber.length !== 11;
  }

  changeNumbersFaToEn(str: string): string {
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

    const l = str.length;
    for (let i = 0; i < l; i += 1) {
      // eslint-disable-next-line
      str = str
        .replace(String(persianNumbers[i]), i.toString())
        .replace(String(arabicNumbers[i]), i.toString());
    }

    return str;
  }

  async handleSendMobileNumber() {
    if (!Login.mobileNumberPattern.test(this.mobileNumber)) {
      return;
    }

    try {
      this.sendMobileNumberLoading = true;

      const response = await fetch(`${process.env.VUE_APP_BASE_URL}api/login`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobile: this.changeNumbersFaToEn(sanitize(this.mobileNumber)),
        }),
      });

      if (response.ok) {
        this.verificationCodeDialog = true;
      } else if (response.status === 403) {
        this.noService = true;
      } else {
        this.retryDialog = true;
      }
    } catch (err) {
      this.$toasted.global.serverError();
    } finally {
      this.sendMobileNumberLoading = false;
    }
  }

  async handleSendVerificationCode() {
    if (!Login.verificationCodePattern.test(this.verificationCode)) {
      return;
    }

    try {
      this.sendVerificationLoading = true;

      const response = await fetch(`${process.env.VUE_APP_BASE_URL}api/verify/${this.changeNumbersFaToEn(sanitize(this.mobileNumber))}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: this.changeNumbersFaToEn(sanitize(this.verificationCode)),
        }),
      });

      if (response.ok) {
        const token = (await response.json()).token;

        this.$store.commit('setToken', token);
        this.$store.commit('setMobile', this.mobileNumber);
        this.$router.replace('/tickets').catch(() => {
          // TODO: Handle this
        });
      } else {
        this.$toasted.global.invalidVerificationCode();
      }
    } catch (err) {
      this.$toasted.global.serverError();
    } finally {
      this.sendVerificationLoading = false;
    }
  }

  closeRetryDialog(retry: boolean) {
    this.retryDialog = false;

    if (retry) {
      this.handleSendMobileNumber();
    }
  }
  closeNoService(retry: boolean) {
    this.noService = false;
  }
}
